<template>
    <div v-if="edit_allowed==='pass'">
        <a class="btn text-light link" target="_blank" :href="editUri">
            {{ mode }} {{ $t('Settings') }}
        </a>
    </div>
    <div v-else>
        <button class="btn text-light link"
                data-bs-toggle="modal"
                data-bs-target="#edit_modal">
            {{ mode }} {{ $t('Settings') }}
        </button>

        <div id="edit_modal"
             class="modal fade"
             role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document" style="width: 600px">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title pb-2" id="myExtraLargeModalLabel">{{ isWarning ? $t('Warning') : $t('Notice') }}</h2>
                        <button type="button" class="btn-close pb-2" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <span v-html="$t(edit_allowed)"></span>
                        <div style="margin-top: 10px; text-align: right">
                            <span v-if="isWarning">
                                <button type="button" class="btn" @click="continueAnyway">{{ $t('OK') }}</button>
                            </span>
                            <button type="button" class="btn" data-bs-dismiss="modal">{{ $t('Close') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";

const props = defineProps({
    mode: {
        type: String,
        required: true,
    },
    patient_id: {
        type: Number,
        required: true,
    },
    history_id: {
        type: Number,
        required: true,
    },
    edit_allowed: {
        type: String,
        required: true
    }
});

const editUri = computed(() => '/patients/' + props.patient_id + '/devices/' + props.history_id + '/settings');

const isWarning = computed( () => {
    if( props.edit_allowed == 'edit_settings.no_ventilator' ) {
        return true;
    }
    return false;
});
const continueAnyway = () => {
    window.open(editUri.value,'_blank');
    document.documentElement.querySelector(".modal.fade.show .btn-close").click();
};
</script>
